// ช่อง 5° × 5° สำหรับหาว่ามีชนิดไหนอยู่แถวเดียวกับเรา (ตาราง range_tile ใน migrations/0005_range_tile.sql)

import { GRID_COLS, type RangeCell } from "../engine/grid";

export const TILE_DEG = 5;
export const TILE_COLS = 360 / TILE_DEG;
export const TILE_COUNT = TILE_COLS * (180 / TILE_DEG);

/** ช่อง 5° ของช่องกริด 1° */
export function tileOfCell(cell: number): number {
  const row = Math.floor(Math.floor(cell / GRID_COLS) / TILE_DEG);
  const col = Math.floor((cell % GRID_COLS) / TILE_DEG);
  return row * TILE_COLS + col;
}

/** ช่อง 5° ทั้งหมดที่ถิ่นที่อยู่นี้ครอบคลุม เรียงจากน้อยไปมาก */
export function rangeTiles(cells: readonly RangeCell[]): number[] {
  return [...new Set(cells.map((c) => tileOfCell(c.cell)))].sort((a, b) => a - b);
}
